import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { DownloadIcon, ClipboardListIcon, UsersIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <DownloadIcon className="w-8 h-8 text-white" data-id="element-83" />,
    title: 'Paso 1',
    description: 'Descargue el PDF e imprímalo (o llénelo digitalmente).'
  }, {
    icon: <ClipboardListIcon className="w-8 h-8 text-white" data-id="element-84" />,
    title: 'Paso 2',
    description: 'Siga las instrucciones paso a paso para completar cada sección.'
  }, {
    icon: <UsersIcon className="w-8 h-8 text-white" data-id="element-85" />,
    title: 'Paso 3',
    description: "Entregue una copia a su hijo o persona de confianza y guarde la suya en 'El Lugar Seguro'."
  }];
  return <section className="py-20 md:py-32 px-6 bg-sage-light" data-id="element-86">
      <div className="max-w-5xl mx-auto" data-id="element-87">
        <FadeIn data-id="element-88">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-16 text-center" data-id="element-89">
            ¿Cómo funciona?
          </h2>
        </FadeIn>

        <div className="relative" data-id="element-90">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-sage/20 z-0" data-id="element-91"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-92">
            {steps.map((step, index) => <FadeIn key={index} delay={0.2 * index} className="flex flex-col items-center text-center" data-id="element-93">
                <div className="w-24 h-24 rounded-full bg-sage flex items-center justify-center shadow-warm mb-6 relative" data-id="element-94">
                  {/* Number badge */}
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-terracotta text-white font-bold flex items-center justify-center border-4 border-sage-light" data-id="element-95">
                    {index + 1}
                  </div>
                  {step.icon}
                </div>
                <h3 className="font-serif text-xl font-semibold text-charcoal mb-3" data-id="element-96">
                  {step.title}
                </h3>
                <p className="text-muted leading-relaxed max-w-xs" data-id="element-97">
                  {step.description}
                </p>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}